<template>
  <iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
    <template #rightContent>
      <div class="feedback-box pl20 pr20 bgfff">
        <van-cell title="我的反馈" title-class="f18 c222 text-left" class="pt20 pl0 pb20 pr0 border-b mb10" center :border="false"
          value-class="cpointer">
          <template>
            <router-link :to="{name:LinkTypeCode.Feedback}">
              <span class="c0F6EE9 f12">反馈问题</span>
            </router-link>
          </template>
        </van-cell>
        <div class="pt20" v-if="list.length&&finished">
          <van-row class="feedbacks">
            <van-col :span="12" v-for="item in list" :key="item.Id" class="pt20 pl20 pr20 border i_radius mb20 feedbackitm"
              @click="$router.push({name:LinkTypeCode.Feedback,query:{Id:item.Id}})">
              <van-cell :value="item.CreateTime" :border="false" value-class="c777 f12" class="pl0 pr0 pt0 pb20">
                <template #title>
                  <div class="custom-text c222 f16 fw600 text-left" :class="{'tagMark':item.IsDispose == 0}">{{item.FeedbackTypeName}}</div>
                </template>
              </van-cell>
              <div class="c777 f14 text-left border-b pb20">
                <span class="ellipsis-row1">{{item.FeedbackContent}}</span>
              </div>
              <van-cell title="查看详情" title-class="c777 f14 text-left" class="pl0 pr0 pt15 pb15"
                value-class="flex align-items-center justify-content-flex-end">
                <template>
                  <van-icon :name="require('@/assets/mine/right-arrow-icon.png')" size="14px" />
                </template>
              </van-cell>
            </van-col>
          </van-row>
        </div>
        <iPagination :currentPage.sync="pageindex" :limit.sync="pageSize" :totalCount="totalCount" @turn="onLoad" v-if="list&&list.length"
          small />
        <EmptyControl style="padding-top: 120px;" v-if="!list.length &&finished" type="feedback" text="还没有反馈历史哦～" />
      </div>
    </template>
  </iMineTemplate>
</template>
<script>
  import { LinkTypeCode } from "@/dictionary/base.js";
  import { BaseMixin } from "../../mixins/BaseMixin.js";
  export default {
    name: "FeedbackHistory",
    mixins: [BaseMixin],
    data() {
      return {
        LinkTypeCode,
        pageTitle: ["帮助中心", "问题反馈"],
        activedParentKey: 4,
        activedKey: 41,
        pageindex: 1,
        pageSize: 10,
        totalCount: 0,
        finished: false,
        list: []
      };
    },
    mounted() {
      this.onLoad();
    },
    methods: {
      async onLoad() {
        await this.getList();
      },
      // 获取列表
      async getList() {
        this.$hys.openLoading();
        const res = await this.getAction("/api_customer/CustomerFeedback/List", {
          pageindex: this.pageindex,
          pagesize: this.pageSize
        });
        this.$hys.clearLoading();
        this.totalCount = res.Count;
        if (this.pageindex == 1) {
          this.list = [];
        }
        if (res.IsSuccess && res.Data.length < this.pageSize) {
          this.finished = true;
        }
        if (res.IsSuccess && res.Data) {
          this.list = this.list.concat(res.Data);
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
          this.finished = true;
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .feedback-box {
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
    width: 100%;
    min-height: 678px;

    .tagMark {
      position: relative;
      padding-left: 16px;

      &:before {
        content: "";
        width: 6px;
        height: 6px;
        background: #ff3939;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .feedbacks {
      .feedbackitm {
        width: calc(50% - 10px);
        cursor: pointer;

        &:nth-child(even) {
          margin-left: 20px;
        }
      }

    }

  }
</style>